/**
 * T4 — ligas de los correos de cobranza. La sesión del portal de Stripe caduca en minutos,
 * así que el correo no la lleva directo: lleva a la app y, tras el login, la app actúa.
 *   · `/pago/actualizar` — cobro rechazado: abre una sesión fresca del portal (tarjeta).
 *   · `/pago/reactivar`  — último rechazo (cuenta suspendida): abre "Pagar adeudo y reactivar".
 */
export const UPDATE_CARD_PATH = '/pago/actualizar';
export const REACTIVATE_PATH = '/pago/reactivar';

const clean = (pathname: string) => pathname.replace(/\/+$/, '');

export const isUpdateCardPath = (pathname: string): boolean => clean(pathname) === UPDATE_CARD_PATH;
export const isReactivatePath = (pathname: string): boolean => clean(pathname) === REACTIVATE_PATH;

/** A dónde recargar tras login. Solo rutas de una allowlist (nunca un redirect abierto). */
export const postLoginPath = (pathname: string): string =>
  isUpdateCardPath(pathname) ? UPDATE_CARD_PATH : isReactivatePath(pathname) ? REACTIVATE_PATH : '/';
